'use client'

import { useEffect } from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'

import { PaymentsIdentityDocumentInfoModel } from '@marketplace-web/pay-identity/payments-identity-data'

import SupportingDocumentFile from '../SupportingDocuments/SupportingDocument/SupportingDocumentFile'
import BankStatementDocumentFile from '../SupportingDocuments/SupportingDocument/BankStatementDocumentFile'
import { SupportingDocumentType } from '../../constants'
import { Field } from '../../types'

type Props = {
  index: number
  title: string
  type: string
  isDisabled: boolean
  mediaTypes?: Array<string>
  maximumFileSize: number
  info?: PaymentsIdentityDocumentInfoModel | null
}

const SupportingDocument = ({
  index,
  title,
  type,
  isDisabled,
  mediaTypes,
  maximumFileSize,
  info,
}: Props) => {
  // TODO: fix typing here by enabling to have useFormContext<FormModel>
  const { control, register, setValue } = useFormContext()

  useEffect(() => {
    const fieldName = `${Field.SupportingDocuments}[${index}]`

    register(`${fieldName}.type`)

    setValue(`${fieldName}.type`, type)
  }, [register, setValue, index, type])

  const { fields } = useFieldArray({
    control,
    name: `${Field.SupportingDocuments}[${index}].files`,
  })

  return (
    <>
      {fields.map((field: any, fileIndex) => {
        const fieldName = `${Field.SupportingDocuments}[${index}].files[${fileIndex}]`

        if (type === SupportingDocumentType.BankStatement) {
          return (
            <BankStatementDocumentFile
              key={field.id}
              fieldName={fieldName}
              identifier={field.identifier}
              title={title}
              type={type}
              isDisabled={isDisabled}
              mediaTypes={mediaTypes}
              maximumFileSize={maximumFileSize}
              index={index}
            />
          )
        }

        return (
          <SupportingDocumentFile
            key={field.id}
            fieldName={fieldName}
            identifier={field.identifier}
            title={title}
            type={type}
            isDisabled={isDisabled}
            mediaTypes={mediaTypes}
            maximumFileSize={maximumFileSize}
            info={info}
            index={index}
          />
        )
      })}
    </>
  )
}

export default SupportingDocument
